import Routes from "@shared/Routes";
import messages_sv from "@translation/sv.json";
import config from "@src/config";

export const SVLANG = messages_sv;
export const ROUTES = Routes;

export const ENVIRONMENTS = {
  Development: "dev",
  Staging: "staging",
  Production: "prod",
};

export const INPUT = {
  NAME: {
    EMAIL: "email",
    PASSWORD: "password",
    NAME: "name",
    USER_NAME: "username",
    MESSAGE: "message",
    PERSONAL_NUMBER: "personalNumber",
    ROLE: "role",
    BANK_ID_TYPE: "bankIdType",
  },
  TYPE: {
    TEXT: "text",
    PASSWORD: "password",
    NUMBER: "number",
  },
};

export const APPLICATION_NAME = "Svenska Fribrevsbolaget";

export const CUSTOMER_SERVICE_EMAIL = "kundservice@svenskafribrevsbolaget.se";

export const TITLE_DIVIDER = " | ";

export const PAGE_NOT_FOUND_CODE = 404;

export const FILE_SIZE_LIMIT = 2000000;

export const ACCEPT_FILE_TYPES = [
  ".doc",
  ".docx",
  ".pdf",
  ".jpg",
  ".jpeg",
  ".png",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "image/jpeg",
  "image/png",
  "image/jpg",
];
export const ORDINARY = "standard";

export const GRID = "GRID";

export const NAV_MENU_ITEMS = [
  {
    label: SVLANG.home,
    redirectTo: Routes.HOME.URL,
    icon: " icon ph-house-bold",
  },
  {
    label: SVLANG.my_insurance,
    redirectTo: Routes.MY_INSURANCE.URL,
    icon: " icon ph-briefcase-bold",
  },
  {
    label: SVLANG.fondtorg,
    redirectTo: Routes.FONDTORG.URL,
    icon: " icon ph-chart-bar-bold",
  },
  {
    label: SVLANG.fund_portfolios,
    redirectTo: Routes.FUND_PORTFOLIOS.URL,
    icon: " icon ph-squares-four-bold",
  },
];

export const NAV_BOTTOM_MENU_ITEMS = [
  {
    label: SVLANG.support,
    redirectTo: Routes.SUPPORT.URL,
    icon: " icon ph-question-bold",
  },
  {
    label: SVLANG.my_affairs,
    isExternalPage: true,
    redirectTo: `${config.EXTERNAL_URL}/user/my_active_cases`,
    icon: " icon ph-list-bullets",
  },
  {
    label: SVLANG.log_out,
    redirectTo: Routes.LOGIN.URL,
    icon: " icon ph-sign-out-bold",
  },
];

export const HEADER_MENU_ITEMS = [
  {
    icon: " icon ph-user-bold",
    redirectTo: Routes.MY_PROFILE.URL,
    label: "",
  },
  {
    label: SVLANG.my_affairs,
    isExternalPage: true,
    redirectTo: `${config.EXTERNAL_URL}/user/my_active_cases`,
    icon: " icon ph-list-bullets",
  },
  {
    icon: " icon ph-question-bold",
    redirectTo: Routes.SUPPORT.URL,
    label: SVLANG.support,
  },
  {
    icon: " icon ph-sign-out-bold",
    redirectTo: Routes.LOGIN.URL,
    label: SVLANG.log_out,
  },
];

export const MONTHS = [
  SVLANG.january,
  SVLANG.february,
  SVLANG.march,
  SVLANG.april,
  SVLANG.may,
  SVLANG.june,
  SVLANG.july,
  SVLANG.august,
  SVLANG.september,
  SVLANG.october,
  SVLANG.november,
  SVLANG.december,
];

export const RISK_VALUES = [1, 2, 3, 4, 5, 6, 7];

export const FUNDS = "funds";

export const REBALANCE = "rebalance";

export const TYPE = "type";

export const ID = "id";

export const UPDATE = "update";

export const UPDATE_ACCEPT = "update-accept";

export const CHANGE_FUND_PORTFOLIO = "change_fund_portfolio";

export const CHANGE_FUNDS = "change_funds";

export const RECOMMENDED_PORTFOLIO = "recommended-portfolio";

export const APPLIES_TO_FUTURE = "APPLIES_TO_FUTURE";

export const APPLIES_TO_CURRENT_FUTURE = "APPLIES_TO_CURRENT_FUTURE";

export const RISK = "risk";

export const RATING = "rating";

export const PERCENTAGE = "percentage";

export const DOWNLOAD = "download";

export const ICON = "icon";

export const FEE_FUND_MANAGEMENT = "Avgift, fond, förvaltning, rörlig";

export const FIXED_ANNUAL_FEE = "Fast årlig avgift";

export const THREE_YEARS = "three_years";

export const ONE_YEAR = "one_year";

export const FIVE_YEARS = "five_years";

export const ONE_MONTH = "one_month";

export const SIX_MONTHS = "six_months";

export const SPECIAL = "special";

export const CURRENCY_CODE = "kr";

export const PERCENT_SIGN = "%";

export const HOME = "Mitt sparande";

export const MY_PROFILE = "Min profil";

export const MY_INSURANCE = "Mina försäkringar";

export const FUND = "Fonder";

export const FUND_PORTFOLIO = "Fondportföljer";

export const SUPPORT = "Kundservice";

export const INSURANCE = "Försäkring";

export const NOTIFICATION = "Mina meddelanden";

export const BANKID = "bankid";

export const ACCOUNTS = "accounts";

export const ALLOCATION = "allocation";

export const TOKEN = "Token";

export const IDENTITY_ID = "IdentityId";

export const BRICK_ID = "brickId";

export const yearToDayFormat = "yyyy-M-dd";

export const ALLOCATION_ORDER_CREATED = "AllocationOrder_Created";

export const ALLOCATION_ORDER_ONGOING = "AllocationOrder_OngoingAllocation";

export const LOGIN_USING_OTHER_MOBILE = "login_using_other_mobile";

export const MOBILE = "Mobile";

export const FILE = "File";

export const AWS_CREDENTIALS = "aws-credentials";

export const BFS_EPOCH = "bfs-epoch";

export const ACTIVE = "WEB";

export const UPDATE_FUND_PORTFOLIO = "update_fund_portfolio";

export const BENEFICIARY_CODE = "Förmånstagarförordnandekod";

export const HELP_DESK_ID = "054ba150-b7cc-422f-80ad-415f94a57cd5";

export const internal_server_error = "Request failed with status code 502";

export const START_YEAR = "00";

export const END_YEAR = "10";

export const NEW_CENTURY = "20";

export const OLD_CENTURY = "19";

export const PORTFOLIO_PDF_DOWNLOAD_LINK = "/media/view/23859";

export const accept_terms_link =
  "https://www.svenskafribrevsbolaget.se/sfb-helhetsplan/";

export const customer_letter_link =
  "https://app.rule.io/browser/a/n_4bp/d/n_fqr2/di/n_rt/s/n_3skx22/e/n_1tsuvo/tt/n_sqov6n";
